(() => {
  // UNIX seconds are absolute. Shift explicitly to +09:00 for Japanese display.
  const state = (el, now) => {
    const start = Number(el.dataset.saleStart), end = Number(el.dataset.saleEnd);
    if (el.dataset.saleEnd && now > end) return 'after';
    if (el.dataset.saleStart && now < start) return 'before';
    return 'open';
  };
  const dateLabel = (seconds, badge = false) => {
    const d = new Date((Number(seconds) + 9 * 3600) * 1000);
    const date = d.getUTCMonth() + 1 + '/' + d.getUTCDate();
    const time = String(d.getUTCHours()).padStart(2, '0') + ':' + String(d.getUTCMinutes()).padStart(2, '0');
    return badge ? date + ' ' + time + '〜受付' : date + '(' + '日月火水木金土'[d.getUTCDay()] + ') ' + time + ' 受付開始';
  };
  let timer;
  const locked = new WeakSet();
  const setText = (el, text) => { if (text != null && el.textContent !== text) el.textContent = text; };
  const update = () => {
    observer.disconnect();
    clearTimeout(timer);
    const now = Math.floor(Date.now() / 1000);
    let next = Infinity;
    document.querySelectorAll('[data-akibart-sale]').forEach(el => {
      const status = state(el, now), blocked = status !== 'open';
      for (const boundary of [Number(el.dataset.saleStart), el.dataset.saleEnd ? Number(el.dataset.saleEnd) + 1 : 0]) {
        if (boundary > now) next = Math.min(next, boundary);
      }
      if (el.hasAttribute('data-sale-badge')) {
        el.hidden = status !== 'before';
        setText(el, status === 'before' ? dateLabel(el.dataset.saleStart, true) : status === 'after' ? '受付終了' : '');
      } else if (el.hasAttribute('data-sale-cart-item')) {
        el.hidden = !blocked;
      } else if (el.matches('button')) {
        const select = el.closest('form')?.querySelector('select[data-akibart-variant]');
        const unavailable = select ? select.selectedOptions[0]?.dataset.available !== 'true' : el.dataset.saleBaseDisabled === 'true';
        const label = el.querySelector('[data-sale-button-label]') || el;
        if (blocked) {
          el.disabled = true;
          setText(label, status === 'before' ? dateLabel(el.dataset.saleStart) : '受付終了');
          locked.add(el);
        } else if (locked.has(el) || el.dataset.saleInitial === undefined) {
          el.disabled = unavailable;
          setText(label, unavailable ? el.dataset.labelUnavailable : el.dataset.labelAvailable);
          locked.delete(el);
        }
        el.dataset.saleInitial = 'true';
      }
    });
    document.querySelectorAll('[data-sale-checkout]').forEach(button => {
      const scope = button.closest('.cart__ctas');
      const blocked = [...scope.querySelectorAll('[data-akibart-sale][data-sale-cart-item]')].some(el => state(el, now) !== 'open');
      button.disabled = blocked || button.dataset.saleBaseDisabled === 'true';
      scope.querySelectorAll('[data-sale-accelerated]').forEach(el => { el.hidden = blocked; });
    });
    observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'data-sale-start', 'data-sale-end'] });
    if (next < Infinity) timer = setTimeout(update, Math.min(next * 1000 - Date.now() + 20, 2147483647));
  };
  const observer = new MutationObserver(update);
  // Capture before product-form handlers, including the existing delayed AJAX add path.
  const guard = event => {
    const form = event.target.closest?.('form');
    const button = event.type === 'submit' ? (event.submitter || form?.querySelector('[name="add"], [name="checkout"]')) : event.target.closest?.('button');
    if (!button) return;
    update();
    if ((button.matches('[data-akibart-sale]') && state(button, Math.floor(Date.now() / 1000)) !== 'open') || (button.hasAttribute('data-sale-checkout') && button.disabled)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  };
  window.addEventListener('submit', guard, true);
  window.addEventListener('click', guard, true);
  document.addEventListener('change', () => queueMicrotask(update));
  document.addEventListener('visibilitychange', update);
  window.addEventListener('pageshow', update);
  update();
})();
